import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { l } from '@manychat/manyui'

import { ActionTypes } from 'common/actions'
import { checkZapierHook } from 'common/audience/actions/audienceActionsTyped'
import { applySubscriberListTag } from 'common/audience/actions/bulkActions'
import * as subscribersActions from 'common/audience/actions/subscribersActions'
import UserListModal from 'common/audience/components/UserListModal'
import WarningModal from 'common/audience/components/UserListModal/WarningModal'

const initialState = {
  isZapierHook: false,
  isTagSelected: false,
  tagId: '',
  tagName: '',
}

class UserListModalController extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    isClearUsers: PropTypes.bool,
    query: PropTypes.shape({
      filter: PropTypes.any,
      active: PropTypes.any,
      q: PropTypes.any,
      messaging_type: PropTypes.any,
    }),

    enableTagging: PropTypes.bool,
  }

  static defaultProps = {
    isClearUsers: true,
  }

  state = { ...initialState }

  componentDidMount() {
    if (this.props.isOpen === true) {
      this.handleOpen(this.props)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen === false && this.props.isOpen === true) {
      this.handleOpen(this.props)
    }
  }

  handleOpen = (props) => {
    props.subscribersActions.fetchSubscriberList(props.query)
  }

  handleClose = () => {
    const { isClearUsers } = this.props

    if (isClearUsers) this.props.subscribersActions.dropSubscribersList()
    this.props.onClose()
    this.setState(initialState)
  }

  handleLoadMore = () => {
    this.props.subscribersActions.fetchNextSubscriberList()
  }

  handleSelectTag = async (tagId, tagName) => {
    const result = await this.props.checkZapierHook(ActionTypes.ADD_TAG, 'tag_id', tagId)
    this.setState({
      isZapierHook: result.has_hook,
      isTagSelected: true,
      tagId: tagId,
      tagName: tagName,
    })
  }

  handleConfirm = () => {
    const { query } = this.props
    const { tagId, tagName } = this.state

    this.props.applySubscriberListTag({
      query,
      tagId,
      tagName,
    })
  }

  getTitle = () => {
    const { items } = this.props
    const { isZapierHook } = this.state

    if (!items) {
      return null
    }

    return (
      <div className="text-center p-x p-y-xs">
        {l.translate('You are going to tag all selected contacts.')}
        {Boolean(isZapierHook) && ' ' + l.translate('In addition, Zapier will be triggered.')}
        {' ' + l.translate('Are you sure?')}
      </div>
    )
  }

  render() {
    const { isOpen, fetching, items, limiter, enableTagging, taggedWith } = this.props
    const { isTagSelected } = this.state

    return isTagSelected && !taggedWith ? (
      <WarningModal
        isOpen={isTagSelected}
        onConfirm={this.handleConfirm}
        onClose={this.handleClose}
        title={this.getTitle()}
      />
    ) : (
      <UserListModal
        isOpen={isOpen}
        onClose={this.handleClose}
        users={items || []}
        loading={items == null || fetching}
        hasMore={Boolean(limiter)}
        onLoadMore={this.handleLoadMore}
        taggedWith={taggedWith}
        onSelectTag={this.handleSelectTag}
        enableTagging={enableTagging}
      />
    )
  }
}

export default connect(
  (state) => state.subscribers,
  (dispatch) => ({
    ...bindActionCreators({ applySubscriberListTag, checkZapierHook }, dispatch),
    subscribersActions: bindActionCreators(subscribersActions, dispatch),
  }),
)(UserListModalController)
